import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import shippingMethodsAdapter from './shipping_methods.adapter';
import actions from './shipping_methods.actions';

import type { ShippingMethod, ShippingMethodSliceInitialState } from './shipping_methods.types';

const initialState: ShippingMethodSliceInitialState = {};

const shippingMethods = createSlice({
  name: 'shippingMethods',
  initialState: shippingMethodsAdapter.getInitialState(initialState),
  reducers: {
    addPendingReplacementShippingMethods(state, { payload }: PayloadAction<ShippingMethod[]>) {
      return {
        ...state,
        pending: payload,
      };
    },
    keepPendingReplacements(state) {
      if (!state.pending) return state;

      const update = shippingMethodsAdapter.setAll(state, state.pending);
      update.pending = undefined;
      return update;
    },
    removePendingReplacements(state) {
      return {
        ...state,
        pending: undefined,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(actions.getAll.fulfilled, (state, { payload }) => {
        return shippingMethodsAdapter.setAll(state, payload);
      })
      .addCase(actions.getPickups.fulfilled, (state, { payload }) => {
        return shippingMethodsAdapter.addMany(state, payload);
      });
  },
});

export default shippingMethods;
